/**
 * コア機能に入れたくないけど、汎用的に使えそうな便利機能。UI関係の操作など。
 * 
 */
export default class Controller{
  constructor(options) {
    this.setOptions(options);
  }
  setOptions(options) {
    this.options = _.defaults(options, {
      /**
       * 施設が全て表示されるようにズームするかどうか
       * @type {Boolean}
       */
      fit_bounds: true,
      /**
       * 検索結果数を表示する要素セレクタ
       * @type {string}
       */
      numberOfResultSelector: '.number-of-result'
    });
  }
  apply(ih) {
    this.ih = ih;
    this.setFitBoundsHook();
    this.setShowNumberOfResult();
    this.setMoveMapMenus();
  }
  /**
   * 
   * 検索後にすべての施設、基準位置がマップ上に表示されるようにする
   */
  setFitBoundsHook() {
    var that = this.ih;
    if (this.options.fit_bounds){
      $(that).on('ihAfterRequestPlaces', (event, req, places) => {
        that.map.fitBounds(places);
      });
    }
  }
  /**
   * 検索後に、検索結果数を更新する
   */
  setShowNumberOfResult() {
    var that = this.ih;
    $(that).on('ihAfterRequestPlaces', (event, request, places) => {
      if (places){
        var num = places.length;
        $(this.options.numberOfResultSelector).text(" (" + num + ")");
      }else{
        $(this.options.numberOfResultSelector).text("");
      }
    });
  }
  /**
   * メニューの「現在地」
   */
  setMoveMapMenus() {
    
    var that = this.ih;
    
    // 地図中心を現在地にする
    // $('.js-move-map-center').on('click', () => {
    //   var latlng = that.map.getCenter();
    //   that.map.updateCurrentLocation(latlng);
    //
    //   that.reSearch({lat: latlng.lat(), lng: latlng.lng()}).then((res) => {
    //     $(that).trigger('ihUpdateCenterMarker', res);
    //   });
    //   $(this).closest('.ui-popup').popup('close');
    // });

    // 現在地マーカの位置に移動
    // $('.js-move-center').on('click', () => {
    //   var loc = that.map.getCurrentSearchLocation();
    //   that.map.moveMap(loc.lat(), loc.lng());
    //   $(this).closest('.ui-popup').popup('close');
    // });

    // GPS現在地連動モードに移行
    // $('.js-user-location').on('click', function() {
    //   var elm = $(this);
    //   that.shiftToLocationMode().then(function(){
    //     elm.closest('.ui-popup').popup('close');
    //   });
    //   return false;
    // });
  
    // 現在地マーカの表示有効範囲（動物園内）
    var minLat = 34.6483;
    var minLng = 135.5066;
    var maxLat = 34.6538;
    var maxLng = 135.5097;
    
    // 「自動的に取得」ボタンによる現在地自動更新を停止するID
    var watchID = null;
    
    // 「自動的に取得」ボタン: GPSで取得した現在地にマーカを設置
    $('.js-user-location').on('click', function() {
  
      // 初期化（GPS追跡停止、現在地マーカ非表示）
      $('.js-move-center').trigger("click");
      
      // 端末・ブラウザから現在地を取得できない場合はエラーを表示
      if (!navigator.geolocation) {
        alert("お使いの端末やブラウザでは現在地を取得できません。")
      } else {
  
        that.displayLoading(true);
  
        // GPSで実際の現在地座標を取得
        watchID = navigator.geolocation.watchPosition(successCallback, errorCallback, {
          enableHighAccuracy: true,    // 高精度を要求する
          timeout: 15000,              // 最大待ち時間（ミリ秒）
          maximumAge: 0                // キャッシュ有効期間（ミリ秒）
        });
  
        // GPSで実際の現在地座標の取得に成功した場合
        function successCallback(position) {
    
          var lat = position.coords.latitude;
          var lng = position.coords.longitude;
    
          // 実際の現在地が表示有効範囲内の場合
          if(
            lat > minLat &&
            lng > minLng &&
            lat < maxLat &&
            lng < maxLng
          ){

            // 現在地マーカを表示
            var currentLoc = that.map.createLatLng(lat, lng);
            that.map.displayCurrentLocationMarker(currentLoc);

            // 現在地マーカ非表示ボタンを有効化
            $('.js-move-center').css('color', 'black');

          // 実際の現在地が表示有効範囲外の場合
          } else {
            
            alert('対象範囲外です。');
  
            // 初期化（GPS追跡停止、現在地マーカ非表示）
            $('.js-move-center').trigger("click");
              
          }
          
          that.displayLoading(false);
        
        }
  
        // GPSで実際の現在地座標の取得に失敗した場合、エラーメッセージを表示
        function errorCallback(error) {
          
          alert('現在地の取得に失敗しました: ' + error.message);
  
          // 初期化（GPS追跡停止、現在地マーカ非表示）
          $('.js-move-center').trigger("click");
  
          that.displayLoading(false);
          
        }
        
      }
      
      $(this).closest('.ui-popup').popup('close');
      
    });
  
    // 「地図中心に設定」ボタン: 閲覧中の地図の中心に現在地マーカーを設置
    $('.js-move-map-center').on('click', () => {
  
      // メニューを閉じる
      $('#page-location').popup('close');
      
      // 初期化（GPS追跡停止、現在地マーカ非表示）
      $('.js-move-center').trigger("click");
      
      // 現在地マーカの表示有効範囲（動物園内）
      var minLoc = that.map.createLatLng(minLat, minLng);
      var maxLoc = that.map.createLatLng(maxLat, maxLng);
  
      // 閲覧中の地図の中心座標を取得
      var latlng = that.map.getCenter();
  
      // 閲覧中の地図の中心座標が表示有効範囲内の場合のみ...
      if(
        latlng.lat() > minLoc.lat() &&
        latlng.lng() > minLoc.lng() &&
        latlng.lat() < maxLoc.lat() &&
        latlng.lng() < maxLoc.lng()
      ){
        
        // 現在地マーカを表示
        that.map.displayCurrentLocationMarker(latlng);
        
        // 現在地マーカ非表示ボタンを有効化
        $('.js-move-center').css('color', 'black');
        
      }
        
    });
  
    // 「表示しない」ボタン: 現在地マーカが非表示の場合、現在地マーカ非表示ボタンをグレーアウト
    $('.js-move-center').css('color', 'darkgray');
  
    // 「表示しない」ボタン: 現現在地マーカを非表示
    $('.js-move-center').on('click', () => {
  
      // メニューを閉じる
      $('#page-location').popup('close');
      
      // 「自動的に取得」ボタンで現在地を表示している場合、現在地の自動更新・描画を停止
      if(watchID){
        navigator.geolocation.clearWatch(watchID);
        watchID = null;
      }
      
      // 現在地マーカが表示されている場合のみ...
      if(that.map.existCurrentLocationMarker()){
        
        // 現在地マーカーを削除
        that.map.clearCurrentLocationMarker();
  
        // 現現在地マーカ非表示ボタンを再びグレーアウト
        $('.js-move-center').css('color', 'darkgray');
        
      }
      
    });
    
  }
}




// WEBPACK FOOTER //
// ./map/js/ih/Controller.js